<template>
  <div id="termsOfServiceContent">
    <div class="tos-content">

      <div class="title">
        <h2>{{ $t('label.termsOfServiceString1')}}</h2>
      </div>
      <p>{{ $t('label.termsOfServiceString3')}}</p>

      <p><span @click="downloadItem('termsOfService')">{{$t('label.termsOfServiceString4')}}</span></p>

      <p class="accept-to-continue">{{ $t('label.termsOfServiceString6')}}</p>
      <el-button class="cstm-btn-gradient width-auto tos-accept-btn" @click="handleAcceptBtnClick">{{$t('label.accept')}}</el-button>
    </div>
    <div class="footer">
    </div>
  </div>
</template>
<script src="./terms-of-service.js"></script>
<style lang="scss" src="./terms-of-service.scss"></style>
